export const GradientHome = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M4.92857 4.28571C4.575 4.28571 4.28571 4.575 4.28571 4.92857V8.78571C4.28571 9.13929 4.575 9.42857 4.92857 9.42857H8.78571C9.13929 9.42857 9.42857 9.13929 9.42857 8.78571V4.92857C9.42857 4.575 9.13929 4.28571 8.78571 4.28571H4.92857ZM3 4.92857C3 3.86384 3.86384 3 4.92857 3H8.78571C9.85045 3 10.7143 3.86384 10.7143 4.92857V8.78571C10.7143 9.85045 9.85045 10.7143 8.78571 10.7143H4.92857C3.86384 10.7143 3 9.85045 3 8.78571V4.92857ZM4.92857 14.5714C4.575 14.5714 4.28571 14.8607 4.28571 15.2143V19.0714C4.28571 19.425 4.575 19.7143 4.92857 19.7143H8.78571C9.13929 19.7143 9.42857 19.425 9.42857 19.0714V15.2143C9.42857 14.8607 9.13929 14.5714 8.78571 14.5714H4.92857ZM3 15.2143C3 14.1496 3.86384 13.2857 4.92857 13.2857H8.78571C9.85045 13.2857 10.7143 14.1496 10.7143 15.2143V19.0714C10.7143 20.1362 9.85045 21 8.78571 21H4.92857C3.86384 21 3 20.1362 3 19.0714V15.2143ZM19.0714 4.28571H15.2143C14.8607 4.28571 14.5714 4.575 14.5714 4.92857V8.78571C14.5714 9.13929 14.8607 9.42857 15.2143 9.42857H19.0714C19.425 9.42857 19.7143 9.13929 19.7143 8.78571V4.92857C19.7143 4.575 19.425 4.28571 19.0714 4.28571ZM15.2143 3H19.0714C20.1362 3 21 3.86384 21 4.92857V8.78571C21 9.85045 20.1362 10.7143 19.0714 10.7143H15.2143C14.1496 10.7143 13.2857 9.85045 13.2857 8.78571V4.92857C13.2857 3.86384 14.1496 3 15.2143 3ZM15.2143 14.5714C14.8607 14.5714 14.5714 14.8607 14.5714 15.2143V19.0714C14.5714 19.425 14.8607 19.7143 15.2143 19.7143H19.0714C19.425 19.7143 19.7143 19.425 19.7143 19.0714V15.2143C19.7143 14.8607 19.425 14.5714 19.0714 14.5714H15.2143ZM13.2857 15.2143C13.2857 14.1496 14.1496 13.2857 15.2143 13.2857H19.0714C20.1362 13.2857 21 14.1496 21 15.2143V19.0714C21 20.1362 20.1362 21 19.0714 21H15.2143C14.1496 21 13.2857 20.1362 13.2857 19.0714V15.2143Z'
        fill='url(#paint0_linear_15181_1219)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_15181_1219'
          x1='1'
          y1='11.7857'
          x2='23'
          y2='11.7857'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#B30000' />
          <stop offset='1' stop-color='#0056B8' />
        </linearGradient>
      </defs>
    </svg>
  )
}
